export type TimeUnit = 'y' | 'm' | 'd' | 'h' | 'min' | 's' | 'ms';
